"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function gvt(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M19.5 8.76975C19.5 12.8257 16.1348 16.125 12 16.125C7.86525 16.125 4.5 12.825 4.5 8.77125C4.5 8.47275 4.518 8.1735 4.5555 7.8765H5.9025C5.8575 8.17275 5.835 8.472 5.835 8.77125C5.835 12.105 8.601 14.8177 12.0007 14.8177C15.2452 14.8177 17.9123 12.3488 18.1508 9.2265H8.61C8.8125 10.6845 9.96225 11.8425 11.4427 12.0817C12.924 12.3202 14.3903 11.5838 15.0592 10.2668H16.503C15.8468 12.1583 14.0355 13.4303 11.9985 13.4318C9.3765 13.4318 7.24275 11.34 7.24275 8.76975C7.24275 8.46975 7.27275 8.16975 7.3305 7.875H19.4445C19.482 8.172 19.5 8.4705 19.5 8.76975Z", fill: color }));
}
exports["default"] = gvt;
//# sourceMappingURL=gvt.js.map